export function __t(key, def) {
    let newKey = key;
    let newDef = def;
    newDef = newDef === undefined ? newKey : newDef;
    newKey = newKey.toUpperCase();
    return lang_constants[newKey] !== undefined ? lang_constants[newKey] : newDef;
}

